import { useEffect } from 'react'
import { useAuth } from 'hooks'
import { useNavigate } from 'react-router'

const SessionManager = () => {
  const { clearUser, isLoggedIn } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isLoggedIn()) {
        clearUser()
        navigate('/login')
      }
    }, 1000 * 60) // check every minute

    return () => clearInterval(interval)
  }, [isLoggedIn, clearUser, navigate])

  return null
}

export default SessionManager
